module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Line</span></div>\r\n<div class=\"row prop-detail\">\r\n<div class=\"row\">\r\n	<div class=\"col-md-6 nopadding-r\">\r\n		<input type=\"color\" id=\"lineColorPicker\" name=\"lineColor\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" value=\"")
    ; __append(escapeFn(lineColor))
    ; __append("\" />\r\n		<input type=\"text\" id=\"lineColor\" name=\"lineColor\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn(lineColor))
    ; __append("\" />\r\n	</div>\r\n	<div class=\"col-md-6 subsection nopadding\" style=\"display: inline-flex;\">\r\n		<label class=\"prop-sublabel label-35\">Size</label>\r\n		<div class=\"nopadding input-group spinSize\">\r\n			")
    ;  if (factoryKey==='control_vertical_separator') { 
    ; __append("\r\n				<input type=\"text\" class=\"form-control\" name=\"width\" id=\"separatorSize\" style=\"width:35px;\" value=\"")
    ; __append(escapeFn(u.extractNum(width)))
    ; __append("\" />\r\n			")
    ;  } else { 
    ; __append("\r\n				<input type=\"text\" class=\"form-control\" name=\"height\" id=\"separatorSize\" style=\"width:35px;\" value=\"")
    ; __append(escapeFn(u.extractNum(height)))
    ; __append("\" />\r\n			")
    ;  }
    ; __append("\r\n			<div class=\"input-group-btn-vertical\">\r\n				<button id=\"btn-up-size\" class=\"btn btn-default\" type=\"button\" style=\"height:12px; padding: 4px 12px;\">\r\n					<span class=\"fa fa-caret-up\"></span>\r\n				</button>\r\n				<button id=\"btn-down-size\" class=\"btn btn-default\" type=\"button\" style=\"height:12px; padding: 4px 12px;\">\r\n					<span class=\"fa fa-caret-down\"></span>\r\n				</button>\r\n			</div>\r\n		</div>\r\n	</div>\r\n	\r\n</div>")
  }
  return __output;

}